import { useEffect, useRef } from "react";
import { BrowseLibrary } from "../components/education/BrowseLibrary";
import { CommunityGroups } from "../components/education/CommunityGroups";
import { RecommendedContent } from "../components/education/RecommendedContent";
import { RequiredTraining } from "../components/education/RequiredTraining";
import { ResumeCard } from "../components/education/ResumeCard";
import { Header } from "../components/Header";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import {
	MOCK_COMMUNITY_GROUPS,
	MOCK_LIBRARY_CATEGORIES,
	MOCK_RECOMMENDED,
	MOCK_RESUME,
	MOCK_TRAINING,
} from "../services/educationService";
import styles from "./EducationHub.module.css";

export function EducationHub() {
	const { logEvent } = useAnalytics();
	const { t } = useClientTranslations("education");

	const hasTrackedPageView = useRef(false);
	useEffect(() => {
		if (!hasTrackedPageView.current) {
			hasTrackedPageView.current = true;
			logEvent("education_hub_page_viewed");
		}
	}, [logEvent]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main}>
				{/* Page title */}
				<div className={styles.pageHeader}>
					<h1 className={styles.pageTitle}>{t("page.title")}</h1>
					<p className={styles.pageSubtitle}>{t("page.subtitle")}</p>
				</div>

				{/* Recommended now section */}
				<section className={styles.section}>
					<div className={styles.sectionHeader}>
						<h2 className={styles.sectionHeading}>
							{t("recommended.heading")}
						</h2>
						<p className={styles.sectionSubtitle}>
							{t("recommended.subtitle")}
						</p>
					</div>
					<RecommendedContent items={MOCK_RECOMMENDED} />
				</section>

				{/* Required training section */}
				<RequiredTraining items={MOCK_TRAINING} />

				{/* Continue where you left off section */}
				<section className={styles.section}>
					<div className={styles.sectionHeader}>
						<h2 className={styles.sectionHeading}>{t("resume.heading")}</h2>
					</div>
					<ResumeCard content={MOCK_RESUME} />
				</section>

				{/* Browse library section */}
				<section className={styles.section}>
					<div className={styles.sectionHeader}>
						<h2 className={styles.sectionHeading}>{t("library.heading")}</h2>
					</div>
					<BrowseLibrary items={MOCK_LIBRARY_CATEGORIES} />
				</section>

				{/* Community groups section */}
				<section className={styles.section}>
					<div className={styles.sectionHeader}>
						<h2 className={styles.sectionHeading}>{t("groups.heading")}</h2>
					</div>
					<CommunityGroups items={MOCK_COMMUNITY_GROUPS} />
				</section>
			</main>
		</div>
	);
}
